import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import Feather from 'react-native-vector-icons/Feather';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import FastImage from '../../../Interface/Images/FastImageWithFallback';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  padding: 0 24px;
  flex: 1;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(4)}px;
`;


export const SectionHeader = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
`;

export const SectionTitleGroup = styled.View`
  flex-direction: column;
  align-items: flex-start;
`;

export const SectionSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
`;

export const SectionBannerContainer = styled.View`
  flex-direction: row;
  justify-content: flex-end;
  width: ${RFValue(165)}px;
`;

export const Section = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const ProductValueContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${RFValue(8)}px;
  flex: 1;
  min-width: 0;
`;

//@ts-ignore
export const ProductImage = styled(FastImage)`
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
`;

export const ValueContainer = styled.View`
  flex: 1;
  flex-shrink: 1;
  min-width: 0;
`;

export const Value = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(16)}px;
  margin-bottom: ${Platform.OS === 'ios' ? RFValue(-4) : RFValue(-8)}px;
`;

export const ValueGroup = styled.View`
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 1;
  width: 100%;
`;

export const ValueDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(11)}px;
  flex-shrink: 1;
`;

export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const SMSValidationContainer = styled.View``;

export const ItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const ItemName = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  align-items: center;
`;

export const ItemContent = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ArrowIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const ButtonLinkRow = styled.View`
  flex-direction: row;
`;

export const ButtonLinkContainer = styled.TouchableOpacity`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
  border-bottom-width: 2px;
  align-items: center;
  flex-direction: row;
`;
export const ButtonLinkText = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;

export const Coupon = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CouponTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;

//@ts-ignore
export const Image = styled(FastImage)`
  width: 100%;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(12)}px;
`;

export const CouponInfo = styled.View``;

export const RemoveCouponButton = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
`;

export const RemoveText = styled.Text`
  color: ${({theme}) => theme.colors.red};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const FooterPromoWrapper = styled.View`
  margin: 0 -24px ${RFValue(8)}px;
  padding: 0 24px;
`;

export const FooterPromoRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(7)}px ${RFValue(8)}px;
  background-color: #fedcd8;
  margin: 0 -24px;
`;

export const FooterPromoTitle = styled.Text`
  flex: 1;
  color: #000;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  margin-right: ${RFValue(4)}px;
`;

export const FooterPromoTitleHighlight = styled.Text`
  color: #ea394e;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const FooterPromoButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.shape};
  padding: ${RFValue(4)}px ${RFValue(8)}px;
  margin-left: ${RFValue(8)}px;
  border-radius: ${RFValue(8)}px;
  border: 0.2px solid #000;
  box-shadow: rgba(255, 0, 0, 0.35) 0px 5px 15px;
`;

export const FooterPromoButtonText = styled.Text`
  color: #000;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const ItemButtonTax = styled.TouchableOpacity`
  width: 100%;
  text-align: left;
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(3)}px;

  margin-top: ${RFValue(5)};
`;

export const ItemButtonTaxText = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const IconButtonTax = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(8)}px;
  margin-left: ${RFValue(6)}px;
  margin-top: 1px;
`;

export const HelpButtonCircle = styled.TouchableOpacity`
  padding: ${RFValue(4)}px;
`;
export const HelpButtonIcon = styled(MaterialCommunityIcons)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(14)}px;
`;

export const CurrentLevelContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(12)}px;
  height: ${RFValue(45)}px;
  border: 1px solid ${({theme}) => theme.colors.blue};
  padding: ${RFValue(6)}px ${RFValue(8)}px;
  border-radius: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.blue_main_opacity};
  margin-top: ${RFValue(6)}px;
  ${({theme}) =>
    Platform.OS === 'ios'
      ? css`
          shadow-color: ${theme.colors.blue};
          shadow-offset: 0px 4px;
          shadow-opacity: 0.15;
          shadow-radius: 4px;
        ` : css`
          elevation: 1;`
      }
`;

export const CurrentCarBadge = styled.View`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(24)}px;

  background-color: ${({theme}) => theme.colors.gold_light};
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-color: ${({theme}) => theme.colors.gold};
`;

export const CurrentLevelInfo = styled.View`
  justify-content: flex-end;
  align-items: flex-end;
`;

export const CurrentLevelName = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(9)}px;
  text-align: right;
  line-height: ${RFValue(12)}px;
  padding-top: ${RFValue(1)}px;
`;

export const BaratinhasCount = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const BaratinhasCountLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  line-height: ${Platform.OS === 'ios' ? undefined : RFValue(12)}px;
  margin-left: ${RFValue(2)}px;
`;
